module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABHklEQVRIid2Vy0oDMRSGvxykMq3IuOuui1q8LbrtzgviXp9G6L50VXwD8QXqUhEfwEcouNIHGId6qTBCJGWgVDAzIZOF/pBFEvi+5ARy1PvhPkAHGALHwDp+mQL3wDnwaARbwAMQe4J/JgV6AgwCwMmZA8nLEionUkHNbVmTgPB5/r5gxbYZja9R8UYhRKcvzM5O3QX66Xk+fGIVZFeXXvDCG6yOLkqDPo4O3AVkGTpJltfqdRBBNRqlxPY3SBK+bm+W1mR3D1WrobpdfwEG1Gwu4Ns7SKtVClxKoKII2ews5rH7n2gv0ecMabcLITpNf90z/UA7H8sh/+Ozmwbkv0neoEPlzgj6eYOuOobZN4KJ6f7AGHitwGIYhtUDJt/mTjvyCDAydAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/xjhyk.png
// module id = u/fk
// module chunks = 1